import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const brands = [
  { name: 'Toyota', logo: '/images/brands/toyota.png' },
  { name: 'Honda', logo: '/images/brands/honda.png' },
  { name: 'BMW', logo: '/images/brands/bmw.png' },
  { name: 'Mercedes', logo: '/images/brands/mercedes.png' },
  { name: 'Audi', logo: '/images/brands/audi.png' },
  { name: 'Ford', logo: '/images/brands/ford.png' },
  { name: 'Chevrolet', logo: '/images/brands/chevrolet.png' },
  { name: 'Nissan', logo: '/images/brands/nissan.png' },
  { name: 'Hyundai', logo: '/images/brands/hyundai.png' },
  { name: 'Kia', logo: '/images/brands/kia.png' },
  { name: 'Volkswagen', logo: '/images/brands/volkswagen.png' },
  { name: 'Lexus', logo: '/images/brands/lexus.png' },
];

const PopularBrands: React.FC = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();

  return (
    <section className="hp-section bg-white">
      <div className="hp-container">
        <div className="hp-section-header">
          <h2>{t('home.brands_title')}</h2>
          <p>{t('home.brands_subtitle')}</p>
        </div>
        <div className="row g-3">
          {brands.map((brand, index) => (
            <div key={index} className="col-6 col-sm-4 col-md-3 col-lg-2">
              <div 
                className="p-3 text-center border rounded-3 shadow-sm d-flex flex-column align-items-center justify-content-center hp-brand-item"
                onClick={() => navigate(`/mysearch?make=${brand.name}`)}
              >
                <div className="hp-brand-logo-wrapper">
                    <img 
                        src={brand.logo} 
                        alt={brand.name} 
                        className="hp-brand-logo"
                        onError={(e) => {
                            // Fallback if image fails
                            e.currentTarget.style.display = 'none';
                        }}
                    />
                </div>
                <span className="fw-bold" style={{ color: '#333', fontSize: '0.9rem' }}>{brand.name}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PopularBrands;
